export default __webpack_public_path__ + "static/satin-long-bd01b5f3a48ef1a5fe6825750b37ebd6.jpg";